import { render, staticRenderFns } from "./notification-settings.vue?vue&type=template&id=585aa484"
import script from "./notification-settings.vue?vue&type=script&lang=js"
export * from "./notification-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports